import uuid from 'uuid/v4';

export const insertHomeworkHint = (state, dispatch) => {
  const {schema, tr} = state;
  const content = schema.text('Hint:');
  const hh = schema.nodes.homeworkHint.createAndFill({id: uuid()}, content);
  dispatch(tr.replaceSelectionWith(hh));
  return true;
};
